function normalizeAskQuestion(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

/** Extract the `Question: …` line from an ask prompt built by BoardAiToolbar. */
export function extractAskQuestionFromMessage(content) {
  const match = String(content || '').match(/^Question:\s*(.+)$/im);
  return match ? match[1].trim() : '';
}

/**
 * Find a persisted conversation that already answered the same recommendation ask.
 * Prefers the most recently updated match with an assistant reply after the question.
 */
export function findCachedAskConversation(conversations, question) {
  const needle = normalizeAskQuestion(question);
  if (!needle || !Array.isArray(conversations)) return null;

  for (const conversation of conversations) {
    const messages = conversation?.messages || [];
    for (let i = 0; i < messages.length; i += 1) {
      const message = messages[i];
      if (message?.role !== 'user') continue;

      const extracted = normalizeAskQuestion(extractAskQuestionFromMessage(message.content));
      if (!extracted || extracted !== needle) continue;

      const hasReply = messages
        .slice(i + 1)
        .some(entry => entry?.role === 'assistant' && String(entry.content || '').trim());
      if (hasReply) return conversation;
    }
  }

  return null;
}
